/**
 * Хук для получения параметров виджета (Query-параметры из URL)
 */
import { useMemo } from 'preact/hooks';

import type { WidgetTheme } from '../types/theme';
import { getWidgetQueryParams, getWidgetUuidQuery } from '../utils';

interface WidgetParams {
  widgetTitle: string;
  companyLogoSrc?: string;
  widgetUuid?: string;
  widgetTheme?: WidgetTheme;
  entryPointGateway?: string;
  requirePhone?: boolean;
  panelOffsetTop?: number;
  hideTriggerButton?: boolean;
  widgetLocale?: string;
}

export const useWidgetParams = ({
  widgetTitle,
  companyLogoSrc,
  widgetUuid,
  widgetTheme,
  entryPointGateway,
  requirePhone,
  panelOffsetTop,
  hideTriggerButton = false,
  widgetLocale,
}: WidgetParams) => {
  return useMemo(() => {
    const queryParams = getWidgetQueryParams();
    const {
      widgetUuid: queryWidgetUuid,
      widgetTitle: queryWidgetTitle,
      companyLogoSrc: queryCompanyLogoSrc,
      widgetTheme: queryWidgetTheme,
      entryPointGateway: queryEntryPointGateway,
      requirePhone: queryRequirePhone,
      panelOffsetTop: queryPanelOffsetTop,
      hideTriggerButton: queryHideTriggerButton,
      widgetLocale: queryWidgetLocale,
    } = queryParams;

    return {
      widgetUuid: getWidgetUuidQuery() ?? queryWidgetUuid ?? widgetUuid,
      widgetTitle: queryWidgetTitle ?? widgetTitle,
      companyLogoSrc: queryCompanyLogoSrc ?? companyLogoSrc,
      widgetTheme: queryWidgetTheme ?? widgetTheme ?? 'default',
      entryPointGateway: queryEntryPointGateway ?? entryPointGateway,
      requirePhone: queryRequirePhone ?? requirePhone,
      panelOffsetTop: queryPanelOffsetTop ?? panelOffsetTop ?? 0,
      hideTriggerButton: queryHideTriggerButton ?? hideTriggerButton,
      widgetLocale: queryWidgetLocale ?? widgetLocale,
    };
  }, [
    widgetTitle,
    companyLogoSrc,
    widgetUuid,
    widgetTheme,
    entryPointGateway,
    requirePhone,
    panelOffsetTop,
    hideTriggerButton,
    widgetLocale,
  ]);
};
